import { useEffect } from 'react';

import Page from '@/ui/components/page';
import SwapForm from '@/ui/components/swap-form';
import { SwapFormSkeleton } from '@/ui/components/swap-form/swap-form';
import exodus from '@/ui/exodus';
import useBalances from '@/ui/hooks/use-balances';
import useExpandedEffect from '@/ui/hooks/use-expanded-effect';
import useModal from '@/ui/hooks/use-modal';
import useSwapAvailability from '@/ui/hooks/use-swap-availability.js';
import showSwapUnavailableModal from '@/ui/modals/swap-unavailable-modal';
import useInitialSwapPair from './hooks/use-initial-swap-pair.js';
import useLocationState from './hooks/use-location-state.js';

const PRIMARY_MODAL_ACTION = {
  label: 'Swap more',
  route: '/swap',
};

const ALTERNATIVE_MODAL_ACTION = {
  label: 'Back to home',
  route: '/',
};

const FAIL_MODAL_ACTION = {
  label: 'Retry swap',
  route: '/swap',
};

function SwapPage() {
  const { token: fromAssetName, referrer } = useLocationState();

  const initialPair = useInitialSwapPair(fromAssetName);

  const {
    value: isAvailable,
    loading: isAvailabilityLoading,
    reason: unavailableReason,
  } = useSwapAvailability();

  const { loading: isBalancesLoading } = useBalances();

  const modal = useModal();

  const loading = isAvailabilityLoading || isBalancesLoading;

  useExpandedEffect(() => {
    exodus.analytics.track({
      event: 'ExchangeView',
      properties: { origin: referrer },
    });
  }, [referrer]);

  useEffect(() => {
    if (loading || isAvailable) {
      // TODO: Remove once swap availability has a loading property.
      if (!modal?.title) {
        modal?.onClose();
      }

      return;
    }

    showSwapUnavailableModal(unavailableReason);
  }, [isAvailable, loading, modal, unavailableReason]);

  return (
    <Page className="flex flex-col gap-y-8 pb-8">
      {loading ? (
        <SwapFormSkeleton />
      ) : (
        isAvailable && (
          <SwapForm
            referrer={referrer}
            submitButtonClassName="mx-4"
            primaryModalAction={PRIMARY_MODAL_ACTION}
            alternativeModalAction={ALTERNATIVE_MODAL_ACTION}
            failModalAction={FAIL_MODAL_ACTION}
            fromAssetName={initialPair?.[0]}
            toAssetName={initialPair?.[1]}
          />
        )
      )}
    </Page>
  );
}

export default SwapPage;
